import { Button, FestiveButton, HeadingTag, IconRenderer, ModuleBase, PreHeading } from '@/components';
import FadeUpAnimation from '@/components/animations/FadeUpAnimation/FadeUpAnimation';
import FadeUpStarter from '@/components/animations/FadeUpAnimation/FadeUpStarter';
import { selectCampaignBottomBackground, selectCampaignTopBackground, selectIsCampaignActive } from '@/store';
import { isColorDark, themeFromBg } from '@/utils';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const HeadingVerticalModule = ({ data }) => {
  const { headingTitle, description, preTitle, primaryCTA, secondaryCTA, backgroundColour, campaignMode } = data || {};
  const [campaignActive, campaignTopBg, campaignBottomBg] = [
    useSelector(selectIsCampaignActive),
    useSelector(selectCampaignTopBackground),
    useSelector(selectCampaignBottomBackground),
  ];
  // eslint-disable-next-line
  const [contentHeight, setContentHeight] = useState(0);
  const content = useRef(null);

  useEffect(() => {
    if (!content.current) return;

    const handleResize = () => {
      setContentHeight(content.current.clientHeight);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ModuleBase
      data={data}
      theme={themeFromBg(!isColorDark(backgroundColour))}
      className={campaignMode && campaignActive ? 'campaign' : ''}
    >
      <FadeUpStarter className="container text-center py-[119px] lg:py-[73px] relative overflow-x-hidden">
        {campaignActive && campaignMode && (campaignTopBg || campaignBottomBg) && (
          // <div
          //   className="absolute pointer-events-none select-none top-0 left-1/2 -translate-x-1/2 lg:translate-x-0 w-[calc(100%-2rem)] md:w-[calc(100%-3rem)] h-full lg:h-[197px] lg:w-full lg:max-w-[min(1175px,81.59%)] lg:top-[70px] lg:left-[11.18%] origin-center [background-repeat:round] bg-[left_top_-10%] lg:bg-no-repeat bg-[length:100%_50%] lg:bg-[length:min(1175px,100%)_100%]"
          //   style={{
          //     backgroundImage: `url("data:image/svg+xml;base64,${Buffer.from(
          //       campaignBg.replace(
          //         /fill="(?!(?:none))[^"]+"/g,
          //         `fill="${isColorDark(backgroundColour) ? '#fff' : '#081B36'}"`,
          //       ),
          //     ).toString('base64')}")`,
          //   }}
          // ></div>
          <>
            <div className="absolute pointer-events-none select-none top-[3%] right-[4%] w-1/3 aspect-[193/101] max-h-[101px] md:w-1/4 lg:w-1/5 md:right-[10%] xl:top-[17%] lg:right-[2%] xl:right-0">
              <IconRenderer selector={selectCampaignTopBackground} className="color-from-bg size-full" />
            </div>
            <div className="absolute pointer-events-none select-none bottom-[2%] left-[4%] w-1/4 aspect-[150/134] max-h-[134px] md:w-1/5 md:left-[8%] xl:bottom-[20%] xl:left-[15%]">
              <IconRenderer selector={selectCampaignBottomBackground} className="color-from-bg size-full" />
            </div>
          </>
        )}
        <div
          className={classNames(
            'title-wrapper lg:w-[773px] lg:mx-auto',
            campaignActive && campaignMode && (campaignTopBg || campaignBottomBg)
              ? 'md:w-[375px] lg:w-[875px] mx-auto'
              : '',
          )}
          role="contentinfo"
          aria-label="contentinfo"
        >
          {preTitle && (
            <FadeUpAnimation>
              <PreHeading
                className={`pre-heading  color-from-bg mb-6 text-[14px] font-[400] font-cera leading-6 tracking-[-0.28px]`}
              >
                {preTitle}
              </PreHeading>
            </FadeUpAnimation>
          )}
          {headingTitle && (
            <FadeUpAnimation>
              <HeadingTag
                data={headingTitle}
                className={`heading-title title font-ivy-ora color-from-bg mb-6
                                text-[40px] font-[400] leading-[44px]
                                lg:text-[56px] lg:leading-[60px] lg:-tracking-normal
                              `}
              />
            </FadeUpAnimation>
          )}
        </div>
        {(description || primaryCTA || secondaryCTA) && (
          <div
            className={classNames(
              'description-wrapper  text-paragraph color-from-bg',
              campaignActive && campaignMode && (campaignTopBg || campaignBottomBg)
                ? 'md:w-[375px] lg:w-[875px] mx-auto'
                : '',
            )}
          >
            <FadeUpAnimation
              dangerouslySetInnerHTML={{ __html: description }}
              className="description font-cera text-[16px] leading-6 lg:w-[400px] lg:mx-auto"
            ></FadeUpAnimation>
            {(primaryCTA || secondaryCTA) && (
              <div className="button-wrapper flex justify-center items-end mt-6">
                <FadeUpAnimation
                  className={` ${secondaryCTA ? 'mr-[66px] first-button-bullet-point' : 'mr-0'} ${themeFromBg(isColorDark(backgroundColour))}`}
                >
                  {campaignActive && campaignMode ? (
                    <FestiveButton link={primaryCTA} />
                  ) : (
                    <Button
                      theme={themeFromBg(isColorDark(backgroundColour))}
                      link={primaryCTA}
                      type={'primary'}
                    ></Button>
                  )}
                </FadeUpAnimation>
                <FadeUpAnimation>
                  {campaignActive && campaignMode ? (
                    <FestiveButton link={secondaryCTA} />
                  ) : (
                    <Button
                      theme={themeFromBg(isColorDark(backgroundColour))}
                      link={secondaryCTA}
                      type={'tertiary'}
                    ></Button>
                  )}
                </FadeUpAnimation>
              </div>
            )}
          </div>
        )}
      </FadeUpStarter>
    </ModuleBase>
  );
};

export default HeadingVerticalModule;
